{
  "tabs": {
    "chat": "Ikiganiro",
    "reminders": "Ibibutsa",
    "calendar": "Kalendari",
    "settings": "Imyanya"
  },
  "common": {
    "cancel": "Hagarika",
    "save": "Bika",
    "confirm": "Emeza",
    "delete": "Siba",
    "back": "Garuka",
    "close": "Funga",
    "edit": "Hindura",
    "search": "Shakisha",
    "all": "Byose",
    "loading": "Birimo gupakira...",
    "error": "Habaye ikosa",
    "notFound": "Ntibibonetse",
    "tryAgain": "Gerageza nanone",
    "retry": "Subira kugerageza",
    "undo": "Subiza inyuma",
    "pullToRefresh": "Kanda usubize",
    "justNow": "Ubu nyine"
  },
  "auth": {
    "welcome": "Murakaza neza muri FishMemory",
    "tagline": "Umufasha wawe wo kwibutsa kuri WhatsApp, ubu uri mu mufuka wawe.",
    "subtitle": "Umufasha wawe wo kwibutsa kuri WhatsApp, ubu uri mu mufuka wawe.",
    "phoneLabel": "Numero ya WhatsApp yawe",
    "phoneHint": "Tuzohereza kode yemeza kuri WhatsApp",
    "invalidPhone": "Injiza numero y'telefone ikwiye",
    "continue": "Komeza",
    "enterPhone": "Injiza numero ya WhatsApp yawe",
    "phonePlaceholder": "Numero ya telefone",
    "sendCode": "Ohereza kode",
    "verifyTitle": "Emeza numero yawe",
    "otpSentTo": "Kode y'inyuguti 6 yoherejwe kuri {{phone}} kuri WhatsApp",
    "enterFullCode": "Injiza inyuguti 6 zose",
    "invalidOtp": "Kode siyo. Gerageza nanone.",
    "otpFailed": "Ntibyashobotse kohereza kode. Gerageza nanone.",
    "otpResent": "Kode yongeye koherezwa",
    "resendIn": "Ohereza nanone mu {{seconds}}s",
    "resendCode": "Ohereza kode nanone",
    "enterOtp": "Injiza kode yoherejwe kuri WhatsApp yawe",
    "verify": "Emeza",
    "resend": "Ohereza kode nanone",
    "wrongNumber": "Numero siyo?",
    "backToPhone": "Garuka ku numero",
    "editPhone": "Hindura numero ya telefone",
    "error": "Ikosa",
    "setupTitle": "Reka dutangire",
    "setupSubtitle": "Ibi ushobora kubihindura nyuma muri Imyanya",
    "namePlaceholder": "Izina ryawe",
    "letsGo": "Hindura setup",
    "skipForNow": "Byirengagize ubu"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Andika ubutumwa...",
    "inputPlaceholder": "Andika ubutumwa...",
    "typing": "FishMemory irimo kwandika...",
    "online": "Ku murongo",
    "connecting": "Irimo guhuzwa...",
    "reconnecting": "Irimo kongera guhuza...",
    "offline": "Nta murongo",
    "empty": "Tangira ikiganiro",
    "emptyHint": "Kora ibibutsa, reba gahunda yawe, cyangwa usabe ubufasha.",
    "emptyAction": "Ohereza urugero rw'ibibutsa",
    "actions": "Ibikorwa by'ikiganiro",
    "keep": "Bika ubutumwa",
    "clearTitle": "Siba ikiganiro",
    "clearConfirm": "Siba ubutumwa bwose kuri iki gikoresho? Ibi ntibishobora gusubizwa inyuma.",
    "clear": "Siba ikiganiro",
    "optionSelected": "Hatoranyijwe: {{label}}",
    "sendingSelection": "Birimo koherezwa...",
    "connectionLost": "Irimo kongera guhuza..."
  },
  "reminders": {
    "title": "Ibibutsa byanjye",
    "active": "Bikora",
    "today": "Uyu munsi",
    "thisWeek": "Icyumweru",
    "history": "Amateka",
    "items": "ibintu",
    "emptyTitle": "Nta bibutsa biriho",
    "emptySubtitle": "Kora kimwe uhereye mu kiganiro kizagaragara hano.",
    "emptyAction": "Fungura ikiganiro",
    "filterActive": "Bikora",
    "filterToday": "Uyu munsi",
    "filterWeek": "Icyumweru",
    "filterHistory": "Amateka",
    "emptyState": "Nta bibutsa biriho. Tangira kuganira!",
    "swipeDone": "Byarangiye",
    "swipeSnooze": "Siba by'agateganyo",
    "swipeDelete": "Siba",
    "search": "Shakisha ibibutsa...",
    "upcoming": "Bizaza",
    "completed": "Byarangiye",
    "overdue": "Byarengeje igihe",
    "tomorrow": "Ejo",
    "synced": "Byahujwe {{value}}",
    "swipeHint": "Soma ibibutsa kugira ngo ubone ibikorwa byinshi",
    "noResults": "Nta bibutsa bihuye n'ubushakashatsi bwawe",
    "noResultsHint": "Gerageza ijambo ritandukanye cyangwa usibe ubushakashatsi",
    "deleteAllFailed": "Ntibyashobotse gusiba ibibutsa byose"
  },
  "calendar": {
    "title": "Kalendari",
    "today": "Uyu munsi",
    "tomorrow": "Ejo",
    "completed": "byarangiye",
    "noEvents": "Nta bikorwa biteganyijwe",
    "noEventsSubtitle": "Hitamo itariki urebe ibibutsa n'ibikorwa bya kalendari.",
    "googleEvent": "Google Calendar",
    "legendActive": "Bikora",
    "legendRecurring": "Bisubirwamo",
    "legendDone": "Byarangiye",
    "legendGoogle": "Google",
    "previousMonth": "Ukwezi gushize",
    "nextMonth": "Ukwezi gutaha",
    "previousYear": "Umwaka ushize",
    "nextYear": "Umwaka utaha",
    "goToToday": "Jya uyu munsi",
    "all": "Byose",
    "active": "Bikora",
    "done": "Byarangiye",
    "paused": "Byahagaze"
  },
  "settings": {
    "title": "Imyanya",
    "profile": "Umwirondoro",
    "name": "Izina ryerekana",
    "enterName": "Injiza izina ryawe",
    "language": "Ururimi",
    "uiLanguage": "Ururimi rwa porogaramu",
    "uiLanguageHelp": "Bihindura interuro za porogaramu, ibimenyetso bya kalendari, n'uburyo bwo kwerekana kuri iki gikoresho gusa.",
    "serverLanguage": "Ururimi rw'ikiganiro",
    "serverLanguageHelp": "Bihindura ururimi rukoreshwa n'ibisubizo bya server n'ubutumwa bw'ibibutsa kuri konti yawe.",
    "timezone": "Isaha y'akarere",
    "currentTimezone": "Isaha y'akarere iriho",
    "timezoneHelp": "Igihe cyose cy'ibibutsa kigaragazwa hakoreshejwe iyi saha y'akarere.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Bika isaha y'akarere",
    "timezoneSaved": "Isaha y'akarere yahinduwe",
    "detect": "Menya",
    "detectFailed": "Ntibyashobotse kumenya isaha y'akarere",
    "autoDetect": "Menya ukoresheje GPS",
    "notifications": "Amatangazo",
    "notificationsHelp": "Ibibutsa bisubirwamo bigenzura amatangazo asubirwamo nyuma y'igihe runaka nyuma yo kubibutsa. Uburenganzira bwo gutanga amatangazo bukomeza kugenzurwa muri imyanya ya telefone yawe.",
    "pushEnabled": "Amatangazo yihutirwa",
    "autoDoneOnFire": "Byikora birangiye iyo bibayeho",
    "autoDoneOnFireDesc": "Iyo bidakora, ibibutsa biguma bikora kugeza ubihaye ko birangiye.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Byahujwe",
    "googleDisconnected": "Ntibyahujwe",
    "googleConnectedHelp": "Ibibutsa bishya bishobora guhuza na kalendari yawe byikora.",
    "googleDisconnectedHelp": "Huzaho Google Calendar kugira ngo ibibutsa n'ibikorwa bihuzwe.",
    "googleConnectFailed": "Ntibyashobotse guhuza Google Calendar",
    "connected": "Byahujwe",
    "disconnected": "Ntibyahujwe",
    "connect": "Huzaho",
    "disconnect": "Hagarika guhuza",
    "autoSync": "Huzaho ibibutsa bishya byikora",
    "autosync": "Huzaho ibibutsa bishya byikora",
    "subscription": "Ubunyamuryango",
    "trialUsed": "Igerageza: {{used}}/{{total}} yakoreshejwe",
    "trialStatus": "Igerageza rirahari",
    "activeStatus": "Ubunyamuryango bukora",
    "expiredStatus": "Ubunyamuryango bwarangiye",
    "unsubscribedStatus": "Ntabwo uri umunyamuryango",
    "about": "Ibyerekeye",
    "version": "Verisiyo",
    "logout": "Sohoka",
    "logoutTitle": "Sohoka",
    "logoutConfirm": "Urizeye ko ushaka gusohoka?",
    "noName": "Nta zina ryashyizweho",
    "serverConnection": "Uburyo bwo guhuza na server",
    "serverUrl": "URL ya server",
    "serverEdit": "Hindura",
    "saveReconnect": "Bika unahuze",
    "resetDefault": "Subiza ku isanzwe",
    "invalidServerUrlTitle": "URL ya server siyo",
    "invalidServerUrlMessage": "Injiza URL ya server ikwiye ya http cyangwa https, urugero https://example.com",
    "uiLanguageChangeFailed": "Ntibyashobotse guhindura ururimi rwa porogaramu. Gerageza nanone.",
    "serverLanguageChangeFailed": "Ntibyashobotse guhindura ururimi rw'ikiganiro. Gerageza nanone.",
    "timezoneChangeFailed": "Ntibyashobotse guhindura isaha y'akarere. Gerageza nanone.",
    "autoSyncChangeFailed": "Ntibyashobotse guhindura auto-sync. Gerageza nanone.",
    "nameChangeFailed": "Ntibyashobotse guhindura izina ryerekana. Gerageza nanone.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Ibisobanuro by'ikibutsa",
    "editTime": "Hindura Igihe",
    "rename": "Hindura izina",
    "snooze": "Siba by'agateganyo",
    "snooze15": "Siba iminota 15",
    "pause": "Hagarika",
    "pauseReminder": "Hagarika ikibutsa",
    "resume": "Komeza",
    "resumeReminder": "Komeza ikibutsa",
    "skip": "Rengaho Ikurikira",
    "skipOccurrence": "Rengaho iki gihe",
    "syncGoogle": "Huzaho na Google",
    "delete": "Siba",
    "deleteTitle": "Siba Ikibutsa",
    "deleteConfirm": "Iki kibutsa kizahora gisibwe burundu.",
    "deleteRecurringTitle": "Siba Ikibutsa Gisubirwamo",
    "deleteRecurringMessage": "Ushaka kurengaho iki gihe cyangwa gusiba byose?",
    "deleteThisOccurrence": "Rengaho Iki Gihe",
    "deleteEntireSeries": "Siba Byose",
    "done": "Byarangiye",
    "markDone": "Shyira ku byarangiye",
    "undo": "Subiza",
    "undoPrompt": "Ukeneye kongera gukora? Subiza ubu.",
    "recurring": "Gisubirwamo",
    "nextRun": "Igihe gikurikira",
    "oneTime": "Igihe kimwe",
    "pending": "Bitegereje",
    "sent": "Byoherejwe",
    "paused": "Byahagaze",
    "active": "Bikora",
    "snoozed": "Byasibwe by'agateganyo",
    "localTime": "Bigaragazwa mu gihe cyawe",
    "recurrence": "Gusubiramo",
    "created": "Byakozwe",
    "tags": "Ibirango",
    "fireCount": "Igihe byabayeho",
    "actions": "Ibikorwa",
    "none": "Nta na kimwe",
    "snoozeFailed": "Ntibyashobotse gusiba by'agateganyo",
    "pauseFailed": "Ntibyashobotse guhagarika ikibutsa",
    "resumeFailed": "Ntibyashobotse gukomeza ikibutsa",
    "skipFailed": "Ntibyashobotse kurengaho ikibutsa",
    "doneFailed": "Ntibyashobotse gushyira ku byarangiye",
    "undoFailed": "Ntibyashobotse gusubiza ikibutsa",
    "deleteFailed": "Ntibyashobotse gusiba ikibutsa",
    "rescheduleTitle": "Wifuza guhindura igihe?",
    "rescheduleMsg": "Iki kibutsa kirarengeje igihe. Wifuza kugihindura?",
    "reschedule15": "Mu minota 15",
    "reschedule60": "Mu isaha 1",
    "keepOverdue": "Komeza uko biri"
  },
  "onboarding": {
    "slide1Title": "Murakaza neza muri FishMemory",
    "slide1Sub": "Umufasha wawe wibutsa bwite — ukoresha WhatsApp kandi wubatswe mu mufuka wawe.",
    "slide2Title": "Ganira uko bisanzwe",
    "slide2Sub": "Andika ibibutsa uko ubyumva: \"Nshishikarize guhamagara mama ejo saa cyenda\" — twe turabikora.",
    "slide3Title": "Ntuzigere ubura ikintu",
    "slide3Sub": "Bona amatangazo ku gihe, utegure ukoresheje ibirango, kandi ukomeze kugenzura iby'ingenzi byose.",
    "getStarted": "Tangira",
    "next": "Kurikira",
    "firstReminderTitle": "Kora ikibutsa cyawe cya mbere!",
    "firstReminderHint": "Gerageza kwandika nka:",
    "firstReminderExample": "Nshishikarize kunywa amazi ejo saa tatu za mu gitondo",
    "gotIt": "Nabyumvise!",
    "notifRationaleTitle": "Igera ku gihe",
    "notifRationaleBody": "FishMemory ikeneye amatangazo kugira ngo ikwibutse ku gihe. Uzahabwa amatangazo gusa y'ibibutsa wakoze.",
    "notifRationaleAllow": "Emeza Amatangazo",
    "notifRationaleLater": "Byashoboka nyuma",
    "swipeHint": "Soma iburyo kugira ngo ubone ibikorwa byihuse →",
    "calendarDragHint": "Kanda ushire hejuru ↕"
  }
}
